import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { addPasskey, authQueryKey, passkeyErrorKey, signOut } from '../../lib/auth.ts';
import { m } from '../../paraglide/messages.js';
import { Banner } from '../../ui/Banner.tsx';
import { Button } from '../../ui/Button.tsx';
import { TextField } from '../../ui/TextField.tsx';
import { AuthScreen } from './AuthScreen.tsx';

/** After a recovery code or login link: the only way on is a new passkey. */
export function AddPasskeyScreen() {
  const queryClient = useQueryClient();
  const [label, setLabel] = useState('');
  const refresh = () => queryClient.invalidateQueries({ queryKey: authQueryKey });
  const mutation = useMutation({
    mutationFn: () => addPasskey(label.trim() || null),
    onSuccess: refresh,
  });
  const cancel = useMutation({ mutationFn: signOut, onSuccess: refresh });

  return (
    <AuthScreen
      title={m.add_passkey_required_title()}
      footer={
        <>
          <Button
            type="submit"
            form="add-passkey-form"
            variant="primary"
            block
            icon="key"
            loading={mutation.isPending}
          >
            {m.passkey_add()}
          </Button>
          <Button variant="ghost" block loading={cancel.isPending} onClick={() => cancel.mutate()}>
            {m.settings_sign_out()}
          </Button>
        </>
      }
    >
      <h1>{m.add_passkey_required_title()}</h1>
      <p className="auth__lead">{m.add_passkey_required_body()}</p>
      <form
        id="add-passkey-form"
        className="auth__form"
        onSubmit={(e) => {
          e.preventDefault();
          mutation.mutate();
        }}
      >
        <TextField
          label={m.passkey_name()}
          maxLength={60}
          value={label}
          onChange={(e) => setLabel(e.target.value)}
        />
      </form>
      {mutation.isError && <Banner variant="error">{m[passkeyErrorKey(mutation.error)]()}</Banner>}
    </AuthScreen>
  );
}
